import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SimpleLineIcons } from '@expo/vector-icons';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { CountdownCircleTimer, } from 'react-native-countdown-circle-timer';
import { Button, HelperText, Text, useTheme, ActivityIndicator, } from 'react-native-paper';
import Colors from 'color';
import { Header40 } from '../typography';
import { OneTimePasswordInput } from './OneTimePasswordInput';
export const OneTimePasswordVerification = ({ value = '', codeLength = 6, disabled = false, error = false, errorMessage = 'Invalid verification code.', processing = false, title = 'Verify Your E-mail Address', subtitle = 'A message with a verification code has been sent to your email. Enter the code to continue.', 
// Set the default duration to 300 seconds (5 minutes)
timerDuration = 300, timerSize = 60, enableTimer = true, showResendVerificationCode = false, disableResendVerificationCode = false, ...restProps }) => {
    const theme = useTheme();
    const [showNoCodeOptions, setShowNoCodeOptions] = useState(false);
    const [timerComplete, setTimerComplete] = useState(false);
    useEffect(() => {
        if (value.length === codeLength && restProps.onCodeComplete) {
            restProps.onCodeComplete();
        }
    }, [value]);
    useEffect(() => {
        if (enableTimer) {
            setTimerComplete(false);
        }
    }, [enableTimer]);
    const onResendVerificationCode = () => {
        setShowNoCodeOptions(false);
        setTimerComplete(false);
        if (restProps.onResendVerificationCode) {
            restProps.onResendVerificationCode();
        }
    };
    // Optionally adjust these intervals relative to the duration.
    const getTimeOutWarningIntervals = () => {
        return [timerDuration / 2, timerDuration / 5, 0];
    };
    const getTimeoutWarningColors = () => {
        return [
            Colors(theme.colors.primary).hex(),
            Colors(theme.colors.secondary).hex(),
            Colors(theme.colors.tertiary).hex(),
        ];
    };
    const renderTimeLeftDisplay = (remainingTime) => {
        return (_jsx(Text, { children: new Date(remainingTime * 1000).toISOString().substring(14, 19) }));
    };
    const onCodeChanged = (code) => {
        if (restProps.onCodeChanged) {
            restProps.onCodeChanged(code);
        }
        if (code.length === codeLength && restProps.onCodeComplete) {
            restProps.onCodeComplete();
        }
    };
    const onTimerComplete = () => {
        setTimerComplete(true);
        if (restProps.onTimerComplete) {
            restProps.onTimerComplete();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(View, { style: { flex: 1, alignItems: 'center' }, children: [_jsx(Header40, { style: { marginVertical: 20 }, children: title }), _jsx(View, { style: { marginVertical: 10 }, children: _jsx(Text, { variant: 'bodyMedium', style: { textAlign: 'center' }, children: subtitle }) })] }), _jsxs(View, { style: { alignItems: 'center', marginVertical: 20 }, children: [_jsxs(View, { style: {
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 20,
                        }, children: [_jsx(OneTimePasswordInput, { value: value, disabled: processing || disabled, length: codeLength, onChangeText: onCodeChanged, keyboardType: 'number-pad' }), _jsxs(HelperText, { visible: error, type: 'error', style: { textAlign: 'center' }, children: [_jsx(SimpleLineIcons, { name: 'exclamation', size: 12, style: { marginHorizontal: 5 } }), errorMessage] }), !showNoCodeOptions && processing && (_jsx(ActivityIndicator, { animating: true, size: 'large', color: theme.colors.primary })), enableTimer && !timerComplete && !processing && (_jsx(CountdownCircleTimer, { strokeWidth: 5, isPlaying: true, isSmoothColorTransition: true, size: timerSize, duration: timerDuration, 
                                // @ts-ignore
                                colorsTime: getTimeOutWarningIntervals(), 
                                // @ts-ignore
                                colors: getTimeoutWarningColors(), onComplete: onTimerComplete, children: ({ remainingTime }) => renderTimeLeftDisplay(remainingTime) }))] }), showNoCodeOptions && (_jsx(Button, { icon: 'refresh', onPress: onResendVerificationCode, loading: processing, children: "Resend Code" })), showResendVerificationCode && !showNoCodeOptions && (_jsx(Button, { loading: processing, disabled: disableResendVerificationCode, onPress: () => setShowNoCodeOptions(true), children: "Didn't get a verification code?" }))] })] }));
};
